import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Box,
  Typography,
  // Divider,
  // Avatar,
   TextField,
  Button,
} from "@mui/material";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";

import CloseIcon from "@mui/icons-material/Close";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import FolderSharedRoundedIcon from '@mui/icons-material/FolderSharedRounded';
import ResourceActivities from "./ResourceActivities";
import { useTheme } from "../../style/theme";

const formatDate = (timestamp) => {
  return new Date(timestamp).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const FIDetailActivity = ({ open, setOpenFIDetailActivity, setOpenSharingDialogModal, onClose, currentMenuClickedItem, setClikkleItems, isFolderInfoActivityTab }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const { mode } = useTheme();

  const [description, setDescription] = useState(currentMenuClickedItem.description);



  useEffect(() => {
    if (isFolderInfoActivityTab === true) {
      setSelectedTab(1);
    } else {
      setSelectedTab(0);
    }
  }, [isFolderInfoActivityTab]);

  const validActivities = ["Accessed", "Renamed", "Viewed"];
  var isFolder = currentMenuClickedItem.type === "folder";
  var resourceTypeName = isFolder ? "Folder" : "File";
  var owner = platformUser._id === currentMenuClickedItem.ownerId ? "Me" : currentMenuClickedItem.ownerEmail
  var lastAccessed = "Not Opened yet"
  try {
    lastAccessed = [...currentMenuClickedItem?.activities]
      .reverse()
      .find(activity => activity.name === "Accessed");
    if (lastAccessed) {
      lastAccessed = `${formatDate(lastAccessed.timestamp)} by ${lastAccessed.by === platformUser._id ? "me" : lastAccessed.by}`
    }
  } catch (e) { }

  var lastModified = "Not modified yet"
  try {
    lastModified = [...currentMenuClickedItem?.activities]
      .reverse()
      .find(activity => validActivities.includes(activity.name));
    if (lastModified) {
      lastModified = `${formatDate(lastModified.timestamp)} by ${lastModified.by === platformUser._id ? "me" : lastModified.by}`
    }
  } catch (e) { }


  var resourceLocation = ""
  if (platformUser._id === currentMenuClickedItem.ownerId) {
    if (currentMenuClickedItem.location.length === 0) {
      resourceLocation = "My Files"
    } else {
      resourceLocation = currentMenuClickedItem.location.split("/").pop().replace("\\", '')
    }
  } else {
    resourceLocation = "Shared with Me"
  }
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };


  const updateDescriptionAPI = async (description) => {
    try {
      // Call the API to rename the item
      const response = await axios.put(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${currentMenuClickedItem._id}`, {
        id: currentMenuClickedItem._id,
        updates: { description: description },
        userId: platformUser._id
      });
      console.log("API Response:", response.data);
      // Update the items array after the API call is successful
      setClikkleItems((prevItems) =>
        prevItems.map((prevItem) =>
          prevItem._id === currentMenuClickedItem._id ? { ...prevItem, description: description } : prevItem
        )
      );
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const handleBlur = () => {
    // Call API when focus is lost
    console.log('description = ', description)
    updateDescriptionAPI(description);
  };

  const onClickManageAccessBtn = () => {
    setOpenFIDetailActivity(false);
    setOpenSharingDialogModal(true);
  };

  // Usage



  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          // backgroundColor: "#191919", // Dark background
          // background: "rgba(31, 31, 31, 1)",
          // 
          background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

          borderRadius: "12px",
          padding: "10px",
          height: "90vh",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {resourceTypeName} Information {selectedTab === 0 ? "Details" : "Activity"}
        <IconButton onClick={onClose} sx={{}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Tabs */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        sx={{
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          px: 2,
        }}
      >
        <Tab label="Details" sx={{ textTransform: "none", }} />
        <Tab label="Activity" sx={{ textTransform: "none", }} />
      </Tabs>

      <DialogContent sx={{ padding: "16px" }}>
        {selectedTab === 0 && (
          <>





            {/* Who Has Access */}

            <Box sx={{ display: "flex", alignItems: "", gap: 3, mb: 3 }}>
              {/* Left Icon */}
              <Box sx={{ flex: 0.5, display: "flex", alignItems: "center", justifyContent: "start" }}>
                <FolderSharedRoundedIcon sx={{ opacity: 0.5, fontSize: 80 }} />
              </Box>


              {/* Right Content - User List */}
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 600, mb: 2 }}>
                  Who has access
                </Typography>

                <Button
                  variant="outlined"
                  onClick={onClickManageAccessBtn}
                  sx={{
                    borderColor: "rgb(55, 103, 177)", borderRadius: "10px",
                    // color: mode === 'dark' ? "rgba(255, 255, 255, 0.9)" : "rgba(85, 85, 85, 0.9)",

                  }}
                >
                  Manage Access
                </Button>

                {/* <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {[
                    { name: "Matthew Rivers (you)", email: "matthewrivers@example.com", role: "Owner" },
                    { name: "Praveen Kumar", email: "praveenkumar@example.com", role: "can view" },
                    { name: "Sandra Oyewole", email: "sandraoyewole@example.com", role: "can view" },
                  ].map((user, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 1,
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Avatar sx={{ width: 30, height: 30 }} />
                        <Box>
                          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>{user.name}</Typography>
                          <Typography sx={{ fontSize: "12px", color: "rgba(255, 255, 255, 0.6)" }}>
                            {user.email}
                          </Typography>
                        </Box>
                      </Box>
                      <Typography sx={{ fontSize: "12px", color: "rgba(255, 255, 255, 0.8)" }}>
                        {user.role}
                      </Typography>
                    </Box>
                  ))}
                </Box> */}
              </Box>
            </Box>

            {/* Security Limitations */}
            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <SecurityOutlinedIcon sx={{ fontSize: "18px", }} />
                <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Security Limitations</Typography>
              </Box>
              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgba(255, 255, 255, 0.6)" : "rgba(85, 85, 85, 0.7)",

              }}>
                No Limitations Applied
              </Typography>
              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgba(255, 255, 255, 0.6)" : "rgba(85, 85, 85, 0.7)",

              }}>
                If any are applied, that will appear here.
              </Typography>
            </Box>

            {/* Folder Details */}
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: 600, mb: 1 }}>{resourceTypeName} Details</Typography>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgba(255, 255, 255, 0.6)" : "rgba(85, 85, 85, 0.7)",

                mb: 1
              }}>
                <b>Type</b>
              </Typography>
              <Typography sx={{ fontSize: "12px", mb: 2 }}>Clikkle Files Folder</Typography>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgba(255, 255, 255, 0.6)" : "rgba(85, 85, 85, 0.7)",

                mb: 1
              }}>
                <b>Location</b>
              </Typography>
              <Button
                variant="outlined"
                sx={{

                  borderColor: mode === 'dark' ? "rgba(255, 255, 255, 0.3)" : "rgba(85, 85, 85, 0.97)",
                  color: mode === 'dark' ? "rgb(255, 255, 255)" : "rgba(85, 85, 85, 0.8)",

                  textTransform: "none",
                  fontSize: "12px",
                  borderRadius: "8px",
                  px: 1.5,
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <FolderOutlinedIcon sx={{ fontSize: "16px" }} />
                {resourceLocation}
              </Button>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgb(255, 255, 255)" : "rgba(85, 85, 85, 0.8)",
                mb: 1
              }}>
                <b>Owner</b>
              </Typography>
              <Typography sx={{ fontSize: "12px", mb: 2 }}>
                {owner}
              </Typography>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgb(255, 255, 255)" : "rgba(85, 85, 85, 0.8)",
                mb: 1
              }}>
                <b>Modified</b>
              </Typography>
              <Typography sx={{ fontSize: "12px", mb: 2 }}>
                {lastModified}
              </Typography>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgb(255, 255, 255)" : "rgba(85, 85, 85, 0.8)",
                mb: 1
              }}>
                <b>Opened</b>
              </Typography>
              <Typography sx={{ fontSize: "12px", mb: 2 }}>
                {lastAccessed}
              </Typography>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgb(255, 255, 255)" : "rgba(85, 85, 85, 0.8)",
                mb: 1
              }}>
                <b>Created</b>
              </Typography>
              <Typography sx={{ fontSize: "12px", mb: 2 }}>
                {formatDate(currentMenuClickedItem.createdAt)}
              </Typography>

              <Typography sx={{
                fontSize: "12px",
                color: mode === 'dark' ? "rgb(255, 255, 255)" : "rgba(85, 85, 85, 0.8)",
                mb: 1
              }}>
                <b>Description</b>
              </Typography>
              <Box
                sx={{ paddingBottom: "0px", maxHeight: "75px" }}

              >
                <TextField
                  sx={{ paddingBottom: "0px", maxHeight: "75px" }}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onBlur={handleBlur}
                  variant="outlined"
                  InputProps={{
                    sx: {
                      backgroundColor: "#222",
                      borderRadius: "8px",
                      background: mode === 'dark' ? "rgba(41, 41, 41, 0.64)" : "rgb(255, 255, 255)",

                      fontSize: "14px",
                      border: "1px solid rgba(41, 41, 41, 1)",
                      maxHeight: "75px", // Limit max height
                      padding: "0px", // Ensure no extra padding
                      "&:hover": {
                        // border: "1px solid rgba(255, 255, 255, 0.4)",
                      },
                      "&.Mui-focused": {
                        // border: "1px solid rgba(255, 255, 255, 0.6)",
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px 14px",
                        color: "rgb(86, 86, 86)",
                        height: "auto",
                        minHeight: "0px",
                        maxHeight: "75px", // Apply max height
                        overflowY: "auto", // Allow scrolling if needed
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    },
                  }}
                  fullWidth
                  multiline
                />

              </Box>

            </Box>
          </>
        )}

        {selectedTab === 1 && (
          <Typography sx={{ fontSize: "14px", color: "rgba(255, 255, 255, 0.6)" }}>
            <ResourceActivities
              mode={mode}
              item={currentMenuClickedItem}
            >

            </ResourceActivities>
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FIDetailActivity;
